import React, { Component } from "react";
import { Row, Col, Button, Card, Container } from "react-bootstrap";
// import DataTableWithOutSearch from "../../datatables/DataTableWithOutSearch";
import BreadcrumbsSection from "../../breadcrumbs/BreadcrumbsSection";
import AddSectionModal from "./AddSectionModal";
import AddSectionModalEdit from "./AddSectionModalEdit";
import SelectDropDown from "../../selectdropdown/SelectDropDown";
import { components } from "react-select";
import MultiSelect from "react-multi-select-component";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import {
  getAuthorizedBranchIds,
  getAuthorizedClassIds,
  getAuthorizedSectionIds,
  filterByAuthorizedIds
} from "../../../utils/authHelper";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import { PageCardShimmer } from "../../preloader/PageCardShimmer";
import CardLessDataTableWithSearch from "../../datatables/CardLessDataTableWithSearch";
import "./_addsection.scss";
import { canView } from "../../../../utils/modulePermissions";
import {
  attachModuleGuard,
  AccessDeniedModal,
  AccessDeniedCard,
} from "../../../../utils/moduleGuard";
import { scopeBranches, onBranchScopeChange } from "../../../../utils/branchScope";

// /settings/sections → "sections" (see MODULE_ROUTES in moduleAccessGuard).
// module_key ONLY, never module_name: "Settings" is the shared sidebar group, and
// can() grants an action when ANY matched row allows it, so matching the group name
// would let a sibling Settings module's grant leak in.
const SECTIONS_MODULE = ["sections"];

const DropdownIndicator = props => {
  return (
    components.DropdownIndicator && (
      <components.DropdownIndicator {...props}>
        <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" className="css-6q0nyr-Svg"><path fill="currentColor" d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path></svg>
      </components.DropdownIndicator>
    )
  );
};

const FIN = {
  wrapper: { background: "linear-gradient(135deg, #f0f4ff 0%, #faf5ff 100%)", minHeight: "100vh", padding: "24px 28px", marginBottom: 100 },
  card: { background: "#fff", borderRadius: 16, boxShadow: "0 4px 24px rgba(0,0,0,0.05)", overflow: "visible", border: "1px solid #e2e8f0" },
  cardHeader: { background: "#ffffff", padding: "20px 24px", display: "flex", alignItems: "center", gap: 14, borderBottom: "1px solid #f1f5f9", flexWrap: "wrap" },
  iconWrapper: { width: 38, height: 38, borderRadius: 10, background: "#f5f3ff", border: "1px solid #ddd6fe", display: "flex", alignItems: "center", justifyContent: "center", color: "#7c3aed", fontSize: 16, flexShrink: 0 },
  titleText: { display: "flex", flexDirection: "column", textAlign: "left" },
  title: { color: "#0f172a", fontWeight: 700, fontSize: 16, margin: 0, letterSpacing: "-0.01em" },
  subtitle: { color: "#64748b", fontSize: 12, fontWeight: 500, marginTop: 2 },
  countChip: { background: "#f5f3ff", color: "#7c3aed", borderRadius: 20, padding: "4px 12px", fontWeight: 600, fontSize: 12, border: "1px solid #ddd6fe" },
  headerActions: { display: "flex", gap: 10, marginLeft: "auto", alignItems: "center", flexWrap: "wrap", },
  btnPrimary: { display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 7, background: "#7c3aed", color: "#fff", border: "none", borderRadius: 9, padding: "10px 16px", fontSize: 13, fontWeight: 600, cursor: "pointer", height: 42 },
  content: { padding: "20px 24px" },
};

// ── Redesigned section module UI (certificate theme) ────────────────────────
const UI = {
  wrap: { background: "linear-gradient(135deg,#eef2ff 0%,#faf5ff 100%)", minHeight: "100vh", padding: "28px 28px 100px" },

  hero: { background: "#fff", borderRadius: 20, padding: "24px 28px", color: "#0f172a", border: "1px solid #eef0f4", boxShadow: "0 4px 24px rgba(0,0,0,0.05)" },
  heroRow: { display: "flex", alignItems: "center", gap: 16, flexWrap: "wrap" },
  heroIcon: { width: 52, height: 52, borderRadius: 14, background: "#eef2ff", color: "#6366f1", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22, flexShrink: 0 },
  heroTitle: { fontWeight: 800, fontSize: 22, margin: 0, letterSpacing: "-0.02em", color: "#0f172a" },
  heroSub: { fontSize: 13, color: "#64748b", marginTop: 3 },
  addBtn: { marginLeft: "auto", display: "inline-flex", alignItems: "center", gap: 8, background: "#6366f1", color: "#fff", border: "none", borderRadius: 12, padding: "12px 20px", fontSize: 14, fontWeight: 700, cursor: "pointer", boxShadow: "0 6px 18px rgba(99,102,241,0.30)" },

  statsRow: { display: "flex", gap: 14, marginTop: 22, flexWrap: "wrap" },
  stat: { background: "#f8fafc", border: "1px solid #eef0f4", borderRadius: 14, padding: "12px 18px", minWidth: 130 },
  statNum: { fontSize: 24, fontWeight: 800, lineHeight: 1, color: "#0f172a" },
  statLabel: { fontSize: 11, color: "#64748b", marginTop: 5, textTransform: "uppercase", letterSpacing: "0.5px" },

  panel: { background: "#fff", borderRadius: 18, boxShadow: "0 4px 24px rgba(0,0,0,0.05)", border: "1px solid #eef0f4", marginTop: 22, overflow: "hidden" },
  toolbar: { display: "flex", alignItems: "center", gap: 12, padding: "16px 20px", borderBottom: "1px solid #f1f5f9", flexWrap: "wrap" },
  toolbarTitle: { fontWeight: 700, fontSize: 15, color: "#0f172a" },
  searchWrap: { position: "relative", minWidth: 260 },
  searchInput: { width: "100%", border: "1.5px solid #e2e8f0", borderRadius: 10, padding: "10px 12px 10px 38px", fontSize: 13, outline: "none", color: "#1f2937", background: "#f8fafc", boxSizing: "border-box" },
  searchIcon: { position: "absolute", left: 13, top: "50%", transform: "translateY(-50%)", color: "#94a3b8", fontSize: 14 },

  // Table — mirrors the certificate module (collapsed table, #f8fafc header,
  // #6b7280 uppercase column labels, soft row dividers).
  tableScroll: { overflowX: "auto" },
  table: { width: "100%", borderCollapse: "collapse", fontSize: 13 },
  th: { textAlign: "left", fontSize: 11, fontWeight: 700, color: "#6b7280", textTransform: "uppercase", letterSpacing: "0.5px", padding: "10px 14px", background: "#f8fafc", borderBottom: "2px solid #e2e8f0", whiteSpace: "nowrap" },
  thRight: { textAlign: "right" },
  td: { padding: "12px 14px", fontSize: 13, color: "#374151", borderBottom: "1px solid #f1f5f9", verticalAlign: "middle" },
  avatar: { width: 32, height: 32, borderRadius: 8, background: "linear-gradient(135deg,#6366f1,#7c3aed)", color: "#fff", display: "inline-flex", alignItems: "center", justifyContent: "center", fontWeight: 700, fontSize: 13, flexShrink: 0 },
  sectionCell: { display: "flex", alignItems: "center", gap: 12 },
  sectionName: { fontWeight: 700, color: "#1f2937" },
  branchChip: { display: "inline-flex", alignItems: "center", gap: 6, background: "#eff6ff", color: "#1d4ed8", borderRadius: 6, padding: "3px 8px", fontSize: 12, fontWeight: 600 },
  classChip: { display: "inline-flex", alignItems: "center", background: "#ede9fe", color: "#5b21b6", borderRadius: 6, padding: "3px 8px", fontSize: 12, fontWeight: 600 },
  actionsCell: { display: "flex", justifyContent: "flex-end", gap: 6 },
  iconBtn: (c) => ({ width: 32, height: 32, borderRadius: 7, border: `1px solid ${c}30`, background: `${c}12`, color: c, display: "inline-flex", alignItems: "center", justifyContent: "center", cursor: "pointer", fontSize: 14 }),
  empty: { textAlign: "center", padding: "64px 20px", color: "#94a3b8" },
  emptyIcon: { fontSize: 40, color: "#cbd5e1", marginBottom: 12 },
  toast: { background: "#ecfdf5", color: "#059669", border: "1px solid #a7f3d0", borderRadius: 10, padding: "10px 16px", fontWeight: 600, fontSize: 13, margin: "16px 20px 0", display: "inline-block" },

  // Pagination — same palette as the certificate module (accent #6366f1, #e2e8f0 borders).
  pagination: { display: "flex", alignItems: "center", gap: 12, padding: "14px 16px", borderTop: "1px solid #f1f5f9", flexWrap: "wrap" },
  pageInfo: { fontSize: 12.5, color: "#6b7280", fontWeight: 600 },
  pageControls: { display: "flex", alignItems: "center", gap: 6, marginLeft: "auto" },
  pageBtn: (disabled) => ({ minWidth: 32, height: 32, borderRadius: 7, border: "1px solid #e2e8f0", background: "#fff", color: disabled ? "#cbd5e1" : "#374151", display: "inline-flex", alignItems: "center", justifyContent: "center", cursor: disabled ? "not-allowed" : "pointer", fontSize: 13, fontWeight: 600, padding: "0 10px" }),
  pageNum: (active) => ({ minWidth: 32, height: 32, borderRadius: 7, border: `1px solid ${active ? "#6366f1" : "#e2e8f0"}`, background: active ? "#6366f1" : "#fff", color: active ? "#fff" : "#374151", display: "inline-flex", alignItems: "center", justifyContent: "center", cursor: "pointer", fontSize: 13, fontWeight: 700 }),
  pageSizeSelect: { border: "1.5px solid #e2e8f0", borderRadius: 7, padding: "7px 10px", fontSize: 12.5, color: "#1f2937", background: "#fff", outline: "none", cursor: "pointer", fontWeight: 600 },
};

const EDIT_SECTION = gql`
  mutation($sections: EditSection) {
    editSection(sections: $sections)
  }
`;

const ADD_SECTION = gql`
  mutation($sections: AddSection) {
    addSection(sections: $sections)
  }
`;

const GETSECTIONCATEGORIES_SECTION = gql`
  query($institution_id: Int!) {
    getCategories(institution_id: $institution_id) {
      id
      category_name
      package_name
      high_difficult
      difficult
      moderate
      easy
    }
  }
`;

const GET_EXAM_CLASSES = gql`
  query($id: Int) {
    getExamClasses(id: $id) {
      id
      class
    }
  }
`;

// Branches with their sections — used to derive which classes belong to a branch
const GET_BRANCHES_WITH_CLASSES = gql`
  query($institution_id: Int!) {
    getBranches(institution_id: $institution_id) {
      id
      branch_name
      sections {
        id
        class_id
      }
    }
  }
`;


const DELETE_SECTION = gql`
  mutation($section_id: ID) {
    deleteSection(section_id: $section_id)
  }
`;

// const GET_EXAM_CLASSES = gql`
//   query getExamClasses($id: Int) {
//     getExamClasses(id: $id) {
//       id
//       class
//     }
//   }
// `;


const GET_BRANCHES = gql`
  query getBranches($institution_id: Int!) {
    getBranches(institution_id: $institution_id) {
      id
      branch_name
      sections {
        id
        class_id
        section_name
      }
    }
  }
`;

// Branch -> class mapping from the Branch Classes settings module (branch_classes).
// Drives which classes are available when creating/editing a section.
const GET_BRANCH_CLASS_MAP = gql`
  query($institute_id: Int!) {
    getInstituteBranchClasses(institute_id: $institute_id) {
      id
      branch_id
      class_id
      class
    }
  }
`;

// Section list built directly from the sections table joined with branch_classes.
const GET_BRANCH_CLASS_SECTIONS = gql`
  query($institute_id: Int!) {
    getSectionsByBranchClasses(institute_id: $institute_id) {
      id
      section_name
      branch_id
      class_id
      category_id
      institution_id
      stream_id
    }
  }
`;

// Streams (MPC/BiPC/...) — only relevant for Class 11 / Class 12 (class_id 1, 2).
// `classes` is a CSV of class_ids the stream applies to.
const GET_STREAMS = gql`
  query {
    getStreams {
      id
      stream
      classes
    }
  }
`;

class AddSectionComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: 1,
      sectionid: "",
      currentStep: 1,
      branch: 0,
      branchvalue: "",
      category: 0,
      categoryvalue: "",
      class: 0,
      classValue: "",
      stream: 0,
      streamvalue: "",
      high_difficult: 0,
      difficult: 0,
      moderate: 0,
      easy: 0,
      section: "",
      package: "",
      submitError: "",
      formErrors: {
        branch: "",
        category: "",
        section: "",
        class: ""
      },
      branchValid: false,
      categoryValid: true,
      sectionValid: false,
      classValid: false,
      formValid: false,

      BranchesSection: {
        Title: "Create New Section",
        btnName: "Add Section"
      },
      tableHeaderData: {
        Title: "Sections"
      },
      modalShow: false,
      modalShow1: false,
      isSaving: false,
      filterClassValue: [],
      hasInitializedClassFilter: false,
      accessDeniedShow: false
    };

    this.guard = attachModuleGuard(this, SECTIONS_MODULE);
  }

  componentDidMount() {
    // Branch comes from the header (NavbarOne). The section list and class filter
    // options are both derived from it at render time, so a re-render is enough.
    this.offBranchScope = onBranchScopeChange(() => this.forceUpdate());
  }

  componentWillUnmount() {
    if (this.offBranchScope) this.offBranchScope();
  }

  componentDidUpdate(prevProps) {
    const branchClasses = this.props.getBranchClassMap?.getInstituteBranchClasses;
    if (branchClasses && !this.state.hasInitializedClassFilter) {
      if (branchClasses.length > 0) {
        // Initialise the class filter from the branch_classes mapping (distinct classes),
        // narrowed to the classes this user is assigned.
        const seen = new Set();
        const filterClassOptions = filterByAuthorizedIds(
          branchClasses,
          getAuthorizedClassIds(),
          "class_id"
        )
          .filter((bc) => {
            if (seen.has(bc.class_id)) return false;
            seen.add(bc.class_id);
            return true;
          })
          .map((bc) => ({ value: bc.class_id, label: bc.class }));
        this.setState({
          filterClassValue: filterClassOptions,
          hasInitializedClassFilter: true
        });
      }
    }
  }

  // Full reset of the Add Section form fields — shared by open + close so the modal
  // always starts blank (no stale branch/category/class/section from a prior open).
  resetAddSectionFields = () => ({
    status: 1,
    sectionid: "",
    currentStep: 1,
    branch: 0,
    branchvalue: "",
    category: 0,
    categoryvalue: "",
    class: 0,
    classValue: "",
    classValid: false,
    stream: 0,
    streamvalue: "",
    high_difficult: 0,
    difficult: 0,
    moderate: 0,
    easy: 0,
    section: "",
    package: "",
    submitError: "",
    formErrors: {
      branch: "",
      category: "",
      section: "",
      class: ""
    },
    branchValid: false,
    categoryValid: true,
    sectionValid: false,
    formValid: false,
    isSaving: false,
  });

  // "Create New Section" — the button stays visible and clickable; the grant is
  // checked here, before the create modal opens, so a role without is_edit gets
  // Access Denied instead of a form it could never submit.
  parentStateSet = () => {
    if (!this.guard.requireEdit()) return;

    // Re-fetch the branch_classes mapping on open so the class dropdown is fresh
    // (picks up class assignments made since the page loaded).
    if (this.props.getBranchClassMap && this.props.getBranchClassMap.refetch) {
      this.props.getBranchClassMap.refetch();
    }
    this.setState({
      ...this.resetAddSectionFields(),
      BranchesSection: {
        Title: "Create New Section",
        btnName: "Add Section"
      },
      tableHeaderData: {
        Title: "Sections"
      },
      modalShow: true,
      modalShow1: false
    });
  };
  selecthandleInputChange = (ename, evalue) => {
    console.log("selecthandleInputChange", this.props.getCategories.getCategories);
    const name = ename;
    const value = evalue;
    if (name == "category") {
      let findData = this.props.getCategories.getCategories.find((a) => a.id == value)
      console.log("categoryfindData", findData);
      this.setState({
        categoryvalue: {
          value: value,
          label: findData.category_name,
        },
        package: findData.package_name,
        high_difficult: findData.high_difficult,
        difficult: findData.difficult,
        moderate: findData.moderate,
        easy: findData.easy
      });
    }
    if (name == "branch") {
      const branchList = (this.props.getBranches && this.props.getBranches.getBranches) || [];
      let findData = branchList.find((a) => a.id == value)
      this.setState({
        branchvalue: {
          value: value,
          label: findData.branch_name,
        },
        // Classes are branch-dependent — clear the selected class on branch change
        classValue: "",
        class: 0,
        classValid: false,
      });
    }

    if (name == "class") {
      const classList = (this.props.getExamClasses && this.props.getExamClasses.getExamClasses) || [];
      let findData = classList.find((a) => a.id == value);
      console.log("finddd", findData);
      this.setState({
        classValue: {
          value: value,
          label: findData ? findData.class : "",
        },
        // Stream only applies to Class 11/12 — clear it whenever the class changes.
        stream: 0,
        streamvalue: "",
      });
    }

    if (name == "stream") {
      const streamList = (this.props.getStreams && this.props.getStreams.getStreams) || [];
      let findData = streamList.find((a) => a.id == value);
      this.setState({
        streamvalue: {
          value: value,
          label: findData ? findData.stream : "",
        },
      });
    }
    this.setState({ [name]: value, submitError: "" }, () => {
      this.validateField(name, value);
    });
  }
  edithandleFormSubmit = e => {
    e.preventDefault();

    // Last gate before editSection. Re-checked at submit, not only when the modal
    // opened: the modal could already be open when a grant changes.
    if (!this.guard.requireEdit()) {
      this.setState({ modalShow1: false });
      return;
    }

    if (this.state.formValid) {
      this.setState({ isSaving: true, submitError: "" });
      let editsectionobj = "";
      editsectionobj = {
        id: this.state.sectionid,
        section_name: this.state.section,
        branch_id: parseInt(this.state.branch),
        category_id: parseInt(this.state.category),
        class_id: parseInt(this.state.class),
        stream_id: this.state.stream ? parseInt(this.state.stream) : 0,
        username: Cookies.get("username")
      };
      this.editsection(editsectionobj).catch(error => {
        console.log("catch if error");
        console.log(error);
        this.setState({
          isSaving: false,
          submitError: error.graphQLErrors.map(x => x.message)
        });
        console.error(
          "ERR =>",
          error.graphQLErrors.map(x => x.message)
        );
      });
    } else {
      this.setState({ submitError: "Please fill all the values to proceed" });
    }
  };
  editsection = async sections => {
    await this.props.editsection({
      variables: {
        sections
      },
      update: (store, { data }) => {
        if (data.editSection) {
          this.setState({
            status: 1,
            sectionid: "",
            currentStep: 5,
            branch_name: "",
            branch: 0,
            category: 0,
            category_name: "",
            high_difficult: 0,
            difficult: 0,
            moderate: 0,
            easy: 0,
            section: "",
            package: "",
            submitError: "",
            formErrors: {
              branch: "",
              category: "",
              section: "",
              class: ""
            },
            branchValid: false,
            categoryValid: false,
            sectionValid: false,
            formValid: false
          });

          setTimeout(() => {
            this.SetpageLoadedit();
          }, 1500);
        }
      }
    });
  };
  SetpageLoadedit = () => {
    this.setState({ currentStep: 1, modalShow1: false });
    window.location.reload(false);
  };
  handleFormSubmit = e => {
    console.log("formsubmit", this.state);
    e.preventDefault();

    // Last gate before addSection. Same reasoning as edithandleFormSubmit.
    if (!this.guard.requireEdit()) {
      this.setState({ modalShow: false });
      return;
    }

    if (this.state.formValid) {
      this.setState({ isSaving: true, submitError: "" });
      let addsectionobj = "";
      addsectionobj = {
        section_name: this.state.section,
        branch_id: parseInt(this.state.branch),
        category_id: parseInt(this.state.category),
        class_id: parseInt(this.state.class),
        stream_id: this.state.stream ? parseInt(this.state.stream) : 0,
        institution_id: parseInt(Cookies.get("institutionid")),
        username: Cookies.get("username")
      };
      this.addsection(addsectionobj).catch(error => {
        console.log("catch if error");
        console.log(error);
        this.setState({
          isSaving: false,
          submitError: error.graphQLErrors.map(x => x.message)
        });
        console.error(
          "ERR =>",
          error.graphQLErrors.map(x => x.message)
        );
      });
    } else {
      this.setState({ submitError: "Please fill all the values to proceed" });
    }
  };
  addsection = async sections => {
    await this.props.addsection({
      variables: {
        sections
      },
      update: (store, { data }) => {
        if (data.addSection) {
          this.setState({
            currentStep: 5,
            branch_name: "",
            branch: 0,
            category: 0,
            category_name: "",
            high_difficult: 0,
            difficult: 0,
            moderate: 0,
            easy: 0,
            section: "",
            package: "",
            submitError: "",
            formErrors: {
              branch: "",
              category: "",
              section: "",
              class: ""
            },
            branchValid: false,
            categoryValid: true,
            sectionValid: false,
            formValid: false
          });

          setTimeout(() => {
            this.SetpageLoad();
          }, 1500);
        }
      }
    });
  };
  SetpageLoad = () => {
    this.setState({ currentStep: 2, modalShow: false });
    window.location.reload(false);
  };
  handleInputChange = e => {
    console.log("e.target.value", e.target.value);
    const name = e.target.name;
    const value = e.target.value;
    this.setState({ [name]: value, submitError: "" }, () => {
      this.validateField(name, value);
    });
  };
  validateField(fieldName, value) {
    let fieldValidationErrors = this.state.formErrors;
    let branchValid = this.state.branchValid;
    let categoryValid = this.state.categoryValid;
    let sectionValid = this.state.sectionValid;
    let classValid = this.state.classValid;

    switch (fieldName) {
      case "branch":
        if (value.length == "") {
          branchValid = false;
          fieldValidationErrors.branch = "Branch Cannot Be Empty";
        } else {
          branchValid = true;
          fieldValidationErrors.branch = "";
        }

        break;
      case "category":
        if (value.length == "") {
          categoryValid = false;
          fieldValidationErrors.category = "Category Cannot Be Empty";
        } else {
          categoryValid = true;
          fieldValidationErrors.category = "";
        }

        break;

      case "class":
        if (value.length == "") {
          classValid = false;
          fieldValidationErrors.class = "Class Cannot Be Empty";
        } else {
          classValid = true;
          fieldValidationErrors.class = "";
        }

        break;

      case "section":
        if (value.length == "") {
          sectionValid = false;
          fieldValidationErrors.section = "Section Cannot Be Empty";
        } else {
          sectionValid = true;
          fieldValidationErrors.section = "";
        }
        break;
      default:
        break;
    }
    this.setState(
      {
        formErrors: fieldValidationErrors,
        branchValid: branchValid,
        categoryValid: categoryValid,
        sectionValid: sectionValid,
        classValid: classValid
      },
      this.validateForm
    );
  }
  validateForm() {
    console.log("validateForm", this.state);
    this.setState({

      formValid:
        this.state.branchValid &&
        this.state.categoryValid &&
        this.state.sectionValid &&
        this.state.classValid
    });
    if (this.state.formValid) {
      this.setState({ submitError: "" }, () => { });
    }
  } 

  commaSeparated = () => {
    // Sections come from the new query (sections + branch_classes only). Names are
    // resolved here: class from the branch_classes mapping, branch from getBranches,
    // category/complexity from the categories list.
    const branchClassMap = (this.props.getBranchClassMap && this.props.getBranchClassMap.getInstituteBranchClasses) || [];
    let displaySections = (this.props.getSectionsDisplay && this.props.getSectionsDisplay.getSectionsByBranchClasses) || [];
    // Show only the sections inside the user's assignment: the branch they belong to,
    // the class they belong to, and the section itself. Each cookie is a comma-separated
    // list (e.g. "10,12,15"); an empty one leaves that dimension unfiltered.
    displaySections = filterByAuthorizedIds(displaySections, getAuthorizedBranchIds(), "branch_id");
    displaySections = filterByAuthorizedIds(displaySections, getAuthorizedClassIds(), "class_id");
    displaySections = filterByAuthorizedIds(displaySections, getAuthorizedSectionIds(), "id");
    const categories = (this.props.getCategories && this.props.getCategories.getCategories) || [];
    const branches = (this.props.getBranches && this.props.getBranches.getBranches) || [];
    const streams = (this.props.getStreams && this.props.getStreams.getStreams) || [];

    let newSectionArray = [];
    for (let i = 0; i < displaySections.length; i++) {
      const edata = displaySections[i];

      const mapMatch = branchClassMap.find(
        (m) => String(m.branch_id) === String(edata.branch_id) && String(m.class_id) === String(edata.class_id)
      );
      const className = mapMatch ? mapMatch.class : "";

      const branchObj = branches.find((b) => String(b.id) === String(edata.branch_id));
      const branchName = branchObj ? branchObj.branch_name : "";

      const catObj = categories.find((a) => a.id == edata.category_id);
      const packagen = catObj ? catObj.package_name : "";
      const high_difficult = catObj ? catObj.high_difficult : 0;
      const difficult = catObj ? catObj.difficult : 0;
      const moderate = catObj ? catObj.moderate : 0;
      const easy = catObj ? catObj.easy : 0;

      const newcomplexity =
        "High Difficult -" + high_difficult + "%" + " , " +
        "Difficult -" + difficult + "%" + " , " +
        "Moderate  -" + moderate + "%" + " , " +
        "Easy -" + easy + "%";

      const newSection = {
        id: edata.id,
        section_name: edata.section_name,
        category_name: catObj ? catObj.category_name : "",
        complexity: newcomplexity,
        branch_id: edata.branch_id,
        category_id: edata.category_id,
        high_difficult: high_difficult,
        difficult: difficult,
        moderate: moderate,
        branch_name: branchName,
        easy: easy,
        package: packagen,
        class_id: edata.class_id,
        class_name: className,
        stream_id: edata.stream_id,
        stream_name: (() => {
          const sm = streams.find((s) => String(s.id) === String(edata.stream_id));
          return edata.stream_id && sm ? sm.stream : "";
        })()
      };
      newSectionArray.push(newSection);
    }
    // Newest first — the most recently added section (highest id) shows on top.
    newSectionArray.sort((a, b) => parseInt(b.id) - parseInt(a.id));
    return newSectionArray;
  };
  // Row "edit" icon — checked before the edit modal opens, so a role without is_edit
  // never sees a form it isn't allowed to save.
  handleEditFunction = (e, cell, row, rowIndex, formatExtraData) => {
    if (!this.guard.requireEdit()) return;

    // Resolve the class label safely from the branch_classes mapping. The row
    // already carries class_name; fall back to the mapping, never crash on no match.
    const branchClassMap = (this.props.getBranchClassMap && this.props.getBranchClassMap.getInstituteBranchClasses) || [];
    const classMatch = branchClassMap.find(
      (m) => String(m.branch_id) === String(rowIndex.branch_id) && String(m.class_id) === String(rowIndex.class_id)
    );
    const classObj = rowIndex.class_id
      ? { value: rowIndex.class_id, label: rowIndex.class_name || (classMatch && classMatch.class) || "" }
      : "";


    this.setState({
      status: 1,
      sectionid: rowIndex.id,
      currentStep: 1,
      branch: rowIndex.branch_id,
      branchvalue: { value: rowIndex.branch_id, label: rowIndex.branch_name },
      category: rowIndex.category_id,
      categoryvalue: { value: rowIndex.category_id, label: rowIndex.category_name },
      high_difficult: rowIndex.high_difficult,
      difficult: rowIndex.difficult,
      moderate: rowIndex.moderate,
      easy: rowIndex.easy,
      section: rowIndex.section_name,
      package: rowIndex.package,
      class: rowIndex.class_id,
      classValue: classObj,
      stream: rowIndex.stream_id || 0,
      streamvalue: (() => {
        const streamList = (this.props.getStreams && this.props.getStreams.getStreams) || [];
        const sm = streamList.find((a) => String(a.id) === String(rowIndex.stream_id));
        return rowIndex.stream_id && sm ? { value: rowIndex.stream_id, label: sm.stream } : "";
      })(),
      submitError: "",
      formErrors: {
        branch: "",
        category: "",
        section: "",
        class: ""
      },
      branchValid: true,
      categoryValid: true,
      sectionValid: true,
      formValid: true,
      classValid: true,

      BranchesSection: {
        Title: "Create New Section",
        btnName: "Add Section"
      },
      tableHeaderData: {
        Title: "Sections"
      },
      isSaving: false,
      modalShow: false,
      modalShow1: true
    });
  };

  handleDelete = async (e, cell, row, rowIndex, formatExtraData) => {
    // Checked BEFORE the confirm prompt: a role without is_delete should be told they
    // lack access, not asked to confirm a delete that was never going to happen.
    if (!this.guard.requireDelete()) return;

    if (!window.confirm(`Are you sure you want to delete section "${rowIndex.section_name}"?`)) {
      return;
    }
    await this.props.handleDelete({
      variables: {
        section_id: rowIndex.id
      },
      update: (store, { data }) => {
        if (data.deleteSection) {
          this.setState({
            status: 2
          });
          setTimeout(() => {
            this.DeleteSetpageLoad();
          }, 1000);
        }
      }
    });
  };
  DeleteSetpageLoad = () => {
    this.setState({ status: 1 });
    window.location.reload(false);
  };

  actionsFormatter(cell, row, rowIndex, formatExtraData) {
    return (
      <div className="actions-buttons d-flex justify-content-center align-items-top">
        <Button variant="link" className="text-theme">
          <i className="far fa-eye" />
        </Button>
      </div>
    );
  }

  actionsFormatter = (cell, row, rowIndex, formatExtraData) => {
    return (
      <div className="actions-buttons d-flex justify-content-center align-items-top">
        <Button variant="link" className="text-theme" onClick={(e) => this.handleEditFunction(e, cell, row, row, formatExtraData)}>
          <i className="far fa-edit" />
        </Button>
        <Button variant="link" className="text-danger" onClick={(e) => this.handleDelete(e, cell, row, row, formatExtraData)}>
          <i className="far fa-trash-alt" />
        </Button>
      </div>
    );
  }

  articlecolumns = [
    {
      dataField: "serial",
      text: "#",
      isDummyField: true,
      headerAlign: "center",
      align: "center",
      formatter: (cell, row, rowIndex) => rowIndex + 1
    },
    {
      dataField: "branch_name",
      text: "Branch",
      sort: true
    },
    {
      dataField: "class_name",
      text: "Class",
      sort: true
    },
    {
      dataField: "stream_name",
      text: "Stream",
      sort: true,
      formatter: (cell) => cell || "--"
    },
    {
      dataField: "section_name",
      text: "Section",
      sort: true
    },
    // {
    //   dataField: "category_name",
    //   text: "Category",
    //   sort: true
    // },
    // {
    //   dataField: "complexity",
    //   text: "Complexity",
    //   sort: true,
    //   headerAlign: "left",
    //   attrs: { className: "complexityRow" }
    // },
    {
      dataField: "actions",
      text: "Actions",
      formatter: this.actionsFormatter,
      headerAlign: "center",
      align: "center"
    }
  ];

  handleFilterChange = (name, value, option) => {
    // No "filterBranch" case — branch comes from the header (NavbarOne).
    if (name === "filterClass") {
      this.setState({
        filterClassValue: option
      });
    }
  };

  render() {
    // is_view === 0 → the section data is never rendered, and the queries below are
    // skipped so nothing is fetched either. This MUST stay above the prop reads that
    // follow: a skipped graphql HOC leaves its prop undefined, and getCategories.loading
    // would throw. The page shell (navbar / sidebar / footer) comes from AddSection.jsx,
    // so the user can still navigate to modules they DO have.
    if (!this.guard.canView()) {
      return (
        <div style={FIN.wrapper} className="add_section_component">
          <AccessDeniedCard />
        </div>
      );
    }

    const getCategories = this.props.getCategories;
    const loading3 = getCategories.loading;
    const error3 = getCategories.error;

    const getBranches = this.props.getBranches;
    const loading4 = getBranches ? getBranches.loading : false;
    const error4 = getBranches ? getBranches.error : undefined;

    const getExamClasses = this.props.getExamClasses;
    const loading5 = getExamClasses ? getExamClasses.loading : false;
    const error5 = getExamClasses ? getExamClasses.error : undefined;

    const getBranchesData = this.props.getBranchesData;
    const getBranchClassMap = this.props.getBranchClassMap;
    const branchClassMap = (getBranchClassMap && getBranchClassMap.getInstituteBranchClasses) || [];

    // Show only the branches the user is authorized for. The branch_id cookie is a
    // comma-separated list (e.g. "10,12,15"), so match against every id.
    const authorizedIds = getAuthorizedBranchIds();
    const filterAuthorizedBranches = (arr) =>
      authorizedIds.length ? (arr || []).filter((b) => authorizedIds.includes(String(b.id))) : (arr || []);
    const authBranches = filterAuthorizedBranches(getBranches && getBranches.getBranches);
    const authBranchesWithClasses = filterAuthorizedBranches(getBranchesData && getBranchesData.getBranches);

    const getSectionsDisplay = this.props.getSectionsDisplay;
    const loading6 = getSectionsDisplay ? getSectionsDisplay.loading : false;
    const error6 = getSectionsDisplay ? getSectionsDisplay.error : undefined;

    if (loading3 || loading4 || loading5 || loading6) return <PageCardShimmer filters={4} />;

    if (error3 !== undefined) {
      alert("Server Error. " + error3.message);
      return null;
    }

    if (error4 !== undefined) {
      alert("Server Error. " + error4.message);
      return null;
    }

    if (error5 !== undefined) {
      alert("Server Error. " + error5.message);
      return null;
    }

    if (error6 !== undefined) {
      alert("Server Error. " + error6.message);
      return null;
    }

    // Branch is no longer a dropdown here: the list is narrowed to the branches the
    // header (NavbarOne) currently has in scope. authBranches stays un-narrowed —
    // the Add/Edit Section modals write a branch_id and need every authorized branch.
    const scopedBranchIds = new Set(
      scopeBranches(getBranches && getBranches.getBranches).map((b) => String(b.id))
    );
    const inScope = (branchId) => scopedBranchIds.size === 0 || scopedBranchIds.has(String(branchId));

    const filterClassIds = (this.state.filterClassValue || []).map((c) => c.value);

    // Class filter options come from the branch_classes mapping, scoped to the header's
    // branches and to the classes this user is assigned.
    const seenFilterClassIds = new Set();
    const filterClassOptions = filterByAuthorizedIds(branchClassMap, getAuthorizedClassIds(), "class_id")
      .filter((bc) => inScope(bc.branch_id))
      .filter((bc) => {
        if (seenFilterClassIds.has(bc.class_id)) return false;
        seenFilterClassIds.add(bc.class_id);
        return true;
      })
      .map((bc) => ({ value: bc.class_id, label: bc.class }));

    const allSections = this.commaSeparated();
    const filteredSections = allSections.filter(sec => {
      const matchesBranch = inScope(sec.branch_id);
      // No class selected => show nothing (empty), instead of showing all.
      const matchesClass = filterClassIds.length > 0 && filterClassIds.includes(sec.class_id);
      return matchesBranch && matchesClass;
    }).sort((a, b) =>
      String(a.class_id ?? "").localeCompare(
        String(b.class_id ?? ""),
        undefined,
        { sensitivity: "base", numeric: true }
      )
    );

    return (
      <div style={UI.wrap} className="add_section">
        <Container fluid className="px-0">

          {/* ── Hero ── */}
          <div style={UI.hero}>
            <div style={UI.heroRow}>
              <div style={UI.heroIcon}><i className="fal fa-th-large" /></div>
              <div>
                <h5 style={UI.heroTitle}>Sections</h5>
                <div style={UI.heroSub}>Organise sections across branches and classes</div>
              </div>

              <div style={FIN.headerActions}>
                <span style={FIN.countChip}>{filteredSections.length} Sections</span>
                <button style={FIN.btnPrimary} onClick={this.parentStateSet}>
                  <i className="fas fa-plus" /> Add Section
                </button>
              </div>

            </div>
            <div style={FIN.content}>

              {/* Class Filter. No Branch filter — the header's branch selection
                  scopes this list. */}
              <div className="mb-4 p-3" style={{ background: "#f8fafc", borderRadius: 12, border: "1px solid #e2e8f0" }}>
                <Row>
                  <Col md={3} sm={12}>
                    <label style={{ fontSize: "11px", fontWeight: "700", textTransform: "uppercase", color: "#64748b", marginBottom: "8px", display: "block" }}>Class Filter</label>
                    <MultiSelect
                      options={filterClassOptions}
                      value={this.state.filterClassValue || []}
                      onChange={(selectedOptions) => this.setState({ filterClassValue: selectedOptions })}
                      labelledBy="Class"
                      overrideStrings={{ allItemsAreSelected: "All Classes selected", selectSomeItems: "Select Class(es)" }}
                    />
                  </Col>
                </Row>
              </div>

              {this.state.status == 2 ? <p style={{ color: "#059669", fontWeight: 600 }}>Section deleted successfully</p> : null}
              <CardLessDataTableWithSearch
                parentData={filteredSections}
                particlecolumns={this.articlecolumns}
                // tableHeading={this.state.tableHeaderData}
                // defaultSorted={defaultSorted}
                branchData={filteredSections}
                name="Sections"
              />
            </div>
          </div>
        </Container>
        <AddSectionModal
          parentselecthandleInputChange={this.selecthandleInputChange}
          stateData={this.state}
          branches={authBranches}
          examClasses={getExamClasses && getExamClasses.getExamClasses}
          branchesWithClasses={authBranchesWithClasses}
          branchClassMap={branchClassMap}
          streams={(this.props.getStreams && this.props.getStreams.getStreams) || []}
          show={this.state.modalShow}
          onHide={() => this.setState({ ...this.resetAddSectionFields(), modalShow: false })}
          parenthandleInputChange={this.handleInputChange}
          parenthandleFormSubmit={this.handleFormSubmit}
          getCategories={getCategories.getCategories}
        />
        <AddSectionModalEdit
          parentselecthandleInputChange={this.selecthandleInputChange}
          stateData={this.state}
          branches={authBranches}
          examClasses={getExamClasses && getExamClasses.getExamClasses}
          branchesWithClasses={authBranchesWithClasses}
          branchClassMap={branchClassMap}
          streams={(this.props.getStreams && this.props.getStreams.getStreams) || []}
          show={this.state.modalShow1}
          onHide={() => this.setState({ modalShow1: false })}
          parenthandleInputChange={this.handleInputChange}
          parenthandleFormSubmit={this.edithandleFormSubmit}
          getCategories={getCategories.getCategories}
        />

        {/* Shown instead of creating / editing / deleting when the grant is missing.
            One modal serves every intercepted action. */}
        <AccessDeniedModal
          show={this.state.accessDeniedShow}
          onHide={this.guard.hideAccessDenied}
        />
      </div>
    );
  }
}
// skip on every READ query: is_view === 0 → the module's data is not fetched at all,
// so it can't sit in the Apollo cache behind the Access Denied card. The mutations
// carry no skip — they're only reachable through the guarded handlers above.
const skipUnlessViewable = () => !canView(SECTIONS_MODULE);

export default withRouter(
  compose(
    graphql(GETSECTIONCATEGORIES_SECTION, {
      options: props => ({
        variables: {
          institution_id: parseInt(Cookies.get("institutionid"))
        }
      }),
      skip: skipUnlessViewable,
      name: "getCategories"
    }),
    graphql(GET_EXAM_CLASSES, {
      options: props => ({
        variables: {
          id: parseInt(Cookies.get("institutionid"))
        }
      }),
      skip: skipUnlessViewable,
      name: "getExamClasses"
    }),
    graphql(GET_BRANCHES_WITH_CLASSES, {
      options: props => ({
        variables: {
          institution_id: parseInt(Cookies.get("institutionid"))
        }
      }),
      skip: skipUnlessViewable,
      name: "getBranchesData"
    }),
    graphql(DELETE_SECTION, {
      name: "handleDelete"
    }),
    graphql(ADD_SECTION, {
      name: "addsection"
    }),
    graphql(EDIT_SECTION, {
      name: "editsection"
    }),
    graphql(GET_BRANCHES, {
      options: props => ({
        variables: {
          institution_id: parseInt(Cookies.get("institutionid"))
        }
      }),
      skip: skipUnlessViewable,
      name: "getBranches"
    }),
    graphql(GET_BRANCH_CLASS_MAP, {
      options: props => ({
        variables: {
          institute_id: parseInt(Cookies.get("institutionid"))
        }
      }),
      skip: skipUnlessViewable,
      name: "getBranchClassMap"
    }),
    graphql(GET_STREAMS, {
      skip: skipUnlessViewable,
      name: "getStreams"
    }),
    graphql(GET_BRANCH_CLASS_SECTIONS, {
      options: props => ({
        variables: {
          institute_id: parseInt(Cookies.get("institutionid"))
        },
        fetchPolicy: "network-only"
      }),
      skip: skipUnlessViewable,
      name: "getSectionsDisplay"
    })
  )(AddSectionComponent)
);
 